export default {
  options: [{
    label: '请选择',
    value: null
  }, {
    label: '服装/鞋/帽',
    value: 67
  }, {
    label: 'IT/数码/电子',
    value: 68
  }, {
    label: '眼镜',
    value: 74
  }, {
    label: '美业/丽人',
    value: 77
  }, {
    label: '宠物',
    value: 78
  }, {
    label: '自选行业旗舰版',
    value: 132
  }]
}



// WEBPACK FOOTER //
// ./src/model/coupon/card-bind/industry-entity.js